module.exports = __webpack_public_path__ + "media/public/img/viator-favicon-01-3ac44546697155a8534be59b9f6eb07e.svg";